export const all_routes = {
  //Home Modules
  homefour: "/index",

  //Course Modules
  courseGrid: "/course/course-grid",
  courseList: "/course/course-list",
  courseDetails: "/course-details/:slug",
  courseDetails2: "/course/course-details-2",
  courseCategory: "/course/course-category",
  courseCategory2: "/course/course-category-2",
  courseCategory3: "/course/course-category-3",
  courseResume: "/course/course-resume",
  courseWatch: "/course/course-watch",
  courseCart: "/course/cart",
  courseCheckout: "/course/checkout",
  addNewCourse: "/course/add-course",
  courses: "/course/courses",
  createCourse: "/course/create-course",

  //Instructor Modules
  instructorDashboard: "/instructor/instructor-dashboard",
  instructorProfile: "/instructor/instructor-profile",
  instructorCourse: "/instructor/instructor-course",
  instructorCourseGrid: "/instructor/instructor-course-grid",
  instructorAnnouncements: "/instructor/instructor-announcements",
  instructorAssignment: "/instructor/instructor-assignment",
  instructorQuiz: "/instructor/instructor-quiz",
  instructorQuizResult: "/instructor/instructor-quiz-results",
  instructorCertificate: "/instructor/instructor-certificate",
  instructorEarning: "/instructor/instructor-earnings",
  instructorPayout: "/instructor/instructor-payout",
  instructorStatements: "/instructor/instructor-statements",
  instructorMessage: "/instructor/instructor-message",
  instructorTickets: "/instructor/instructor-tickets",
  instructorChangePassword: "/instructor/instructor-change-password",
  instructorPlan: "/instructor/instructor-plans",
  instructorSocialProfiles: "/instructor/instructor-social-profiles",
  instructorLinkedAccounts: "/instructor/instructor-linked-accounts",
  instructorNotification: "/instructor/instructor-notifications",
  instructorIntegrations: "/instructor/instructor-integrations",
  instructorWithdraw: "/instructor/instructor-withdraw",
  instructorWishlist: "/instructor/instructor-withdraw",
  instructorReviews: "/instructor/instructor-withdraw",
  instructorQuizAttempts: "/instructor/instructor-withdraw",
  instructorOrders: "/instructor/instructor-withdraw",
  instructorChat: "/instructor/instructor-withdraw",
  instructorReferral: "/instructor/instructor-withdraw",
  instructorQA: "/instructor/instructor-quiz-questions",
  instructorsettings: "/instructor/instructor-settings",

  studentDashboard: "/student/student-dashboard",
  studentProfile: "/student/student-profile",
  studentsGrid: "/instructor/students",
  studentsDetails: "/instructor/students-details",
  studentsList: "/instructor/student-list",
  studentOrderHistory: "/student/student-order-history",
  studentMessage: "/student/student-messages",
  studentCourses: "/student/student-courses",
  studentCertificates: "/student/student-certificates",
  studentReviews: "/student/student-reviews",
  studentWishlist: "/student/student-wishlist",
  studentQuiz: "/student/student-quiz",
  studentQuizQuestion: "/student/student-quiz-questions",
  studentReferral: "/student/student-referral",
  studentTickets: "/student/student-tickets",
  studentSettings: "/student/student-settings",
  studentChangePassword: "/student/student-change-password",
  studentSocialProfile: "/student/student-social-profile",
  studentLinkedAccounts: "/student/student-linked-accounts",
  studentNotification: "/student/student-notifications",
  studentBillingAddress: "/student/student-billing-address",

  cart: "/cart",
  login: "/login",
  //register: "/register",
  forgotpassword: "/forgot-password",
  setpassowrd: "/set-password",
  otp: "/otp",
  lockscreen: "/lock-screen",
  privacyPolicy: "/pages/privacy-policy",
  termsConditions: "/terms-conditions",
  contactUs: "pages/contact-us",
  about_us: "/pages/about-us",
  invoices: "/pages/invoices",
  FAQ: "/pages/faq",
  eligibilitycheck: "/pages/check-eligibility",
  ausbildungFinder: "/ausbildung",
  fsjBfdCircular: "/fsj-bfd-circular",
  cvMotivationLetterCheck: "/cv-motivation-letter-check",
  visaWaitingTimeTracker: "/visa-waiting-time-tracker",
  salaryCalculator: "/ausbildung-salary-calculator",
  ausbildungFromBangladesh: "/ausbildung-in-germany-from-bangladesh",
  fsjBfdFromBangladesh: "/fsj-bfd-in-germany-from-bangladesh",
  studyFromBangladesh: "/study-in-germany-from-bangladesh",
  germanInBangladesh: "/learn-german-language-in-bangladesh",
  ausbildungFavourites: "/ausbildung/favourites",
  ausbildungSector: "/ausbildung/:sectorSlug",
  ausbildungProfession: "/ausbildung/:sectorSlug/:professionSlug",
  pricingPlan: "/pages/pricing-plan",
  Error404: "/pages/error-404",
  Error500: "/pages/error-500",
  underconstruction: "/pages/under-construction",
  comingSoon: "/pages/coming-soon",
  becomeAnInstructor: "/pages/become-an-instructor",
  instructorList: "/pages/instructor-list",
  instructorGrid: "/pages/instructor-grid",
  instructorDetails: "/pages/instructor-details",
  notification: "/pages/notifications",
  testimonials: "/pages/testimonials",
  bookAppointment: "pages/book-appointment",
  faq: "/pages/faq",
  blog: "/pages/blog",

  blogGrid: "/blog/blog-grid",
  blogGrid2: "/blog/blog-2-grid",
  blogGrid3: "/blog/blog-3-grid",
  blogDetails: "/blog/blog-details",
  blogCarousal: "/blog/blog-carousal",
  blogMasonry: "/blog/blog-masonry",
  blogLeftSidebar: "/blog/blog-left-sidebar",
  blogRightSidebar: "/blog/blog-right-sidebar",
  blogDetailsLeftSidebar: "/blog/blog-details-left-sidebar",
  blogDetailsRightSidebar: "/blog/blog-details-right-sidebar",
};
